"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateManuallyAcceptedAuditTrail = void 0;
var ImageImports_1 = require("Common/Utils/ImageImports");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var generateManuallyAcceptedAuditTrail = function (projectStore) { return __awaiter(void 0, void 0, void 0, function () {
    var pageStateHistory;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, projectStore.getPageStateHistory()];
            case 1:
                pageStateHistory = _a.sent();
                return [2, [getPublishedData(projectStore, pageStateHistory), getAcceptedData(pageStateHistory)]];
        }
    });
}); };
exports.generateManuallyAcceptedAuditTrail = generateManuallyAcceptedAuditTrail;
var getPublishedData = function (projectStore, pageStateHistory) {
    var latestPublish = pageStateHistory.find(function (p) { return p.state.status === Types_1.ProjectStatus.Live; });
    if (latestPublish) {
        return {
            name: "Published Page",
            cssClass: "published",
            icon: ImageImports_1.Projects,
            timestamp: latestPublish.createdAt,
            subtitle: (0, GetFullName_1.default)(latestPublish.user),
            table: [
                {
                    label: "Email",
                    value: latestPublish.user.email,
                },
            ],
        };
    }
    return {
        name: "Published Page",
        cssClass: "published",
        icon: ImageImports_1.Projects,
        timestamp: projectStore.publishedTimestamp,
        table: [
            {
                label: "",
                value: "",
            },
        ],
    };
};
var getAcceptedData = function (pageStateHistory) {
    var acceptedState = pageStateHistory.find(function (s) { return s.state.status === Types_1.ProjectStatus.Accepted; });
    return {
        name: "Manually Accepted",
        cssClass: "signed-accepted",
        icon: ImageImports_1.Accept,
        timestamp: acceptedState.createdAt,
        table: [
            { label: "By", value: (0, GetFullName_1.default)(acceptedState.user) },
            { label: "Email", value: acceptedState.user.email },
        ],
    };
};
